import React, { Component } from 'react'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import { Col, Row } from 'react-bootstrap'
import { Heading, ContainerBox } from './AdminStyle';
import { LogeButtonSlim } from '../GeneralStyle'
import ConfirmSendNewContractsModal from "../internal/Modals/ConfirmSendNewContractsModal"
import ConfirmSendNewInvoicesModal from "../internal/Modals/ConfirmSendNewInvoicesModal"
import ApplicationTable from '../Tables/ApplicationTable';
import styled from 'styled-components'
import Parse from 'parse'


@inject('userStore', 'adminStore')

@observer
class Dashboard extends Component {

  constructor(props) {
    super(props)
    this.state = {
      // today: 0,
      // lastMonth: 0,
      lastYear: 0,
      thisYear: 0,
      beforeLastYear: 0,

      info_leads: 0,
      application_leads: 0,
      member_leads: 0,
    }
  }

  componentWillMount() {
    this.props.adminStore.getApplications()

    Parse.Cloud.run('getDashboardAnalytics').then(data => {
      this.setState(data)
    })

    const before_90_days = new Date()
    before_90_days.setDate( before_90_days.getDate() - 90 );


    new Parse.Query("InformationRequest").greaterThanOrEqualTo('createdAt', before_90_days).count().then( res => this.setState({ info_leads: res }))
    new Parse.Query("Application").greaterThanOrEqualTo('createdAt', before_90_days).count().then( res => this.setState({ application_leads: res }))
    new Parse.Query("Company").greaterThanOrEqualTo('createdAt', before_90_days).count().then( res => this.setState({ member_leads: res }))
  }

  render() {
    const { isAdmin, isLoge } = this.props.userStore;

    const { applications } = this.props.adminStore;

    if (!isAdmin) {
      //this.props.history.push("/")
    }

    return (
      <div>
      {(isAdmin || isLoge) ?
          <div>
            <Row style={{maxWidth: 1200, margin: "0 auto"}}>
              <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} >
              <ContainerBox style={{paddingBottom: 25, textAlign: "center", marginBottom: 0}}>
                <Row style={{maxWidth: 1200, margin: "0 auto"}}>
                <Col xs={12} md={4} lg={4} className={'mobile-no-padding'} >
                    <Heading style={{padding: 0}}>Vorletztes Jahr</Heading>
                    <div style={{ marginLeft: 15, marginRight: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "50%", marginBottom: 10, display: "inline-block" }}></div>

                    <NumberDisplay>{ this.state.beforeLastYear }</NumberDisplay>
                    <Information>Buchungen</Information>
                </Col>
                <Col xs={12} md={4} lg={4} className={'mobile-no-padding'} >
                    <Heading style={{padding: 0}}>Letztes Jahr</Heading>
                    <div style={{ marginLeft: 15, marginRight: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "50%", marginBottom: 10, display: "inline-block" }}></div>

                    <NumberDisplay>{ this.state.lastYear }</NumberDisplay>
                    <Information>Buchungen</Information>
                </Col>
                <Col xs={12} md={4} lg={4} className={'mobile-no-padding'} >
                    <Heading style={{padding: 0}}>Dieses Jahr</Heading>
                    <div style={{ marginLeft: 15, marginRight: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "50%", marginBottom: 10, display: "inline-block" }}></div>

                    <NumberDisplay>{ this.state.thisYear }</NumberDisplay>
                    <Information>Buchungen</Information>
                </Col>
                <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} style={{textAlign: "center", marginTop: 35}} >
                  <LogeButtonSlim
                    hoverFontColor={"white"}
                    onClick={() => this.props.history.push(`/internal/admin/analytics`)}>
                      Alle Statistiken anzeigen
                  </LogeButtonSlim>
                </Col>
                </Row>
                </ContainerBox>
              <ContainerBox style={{paddingBottom: 25, textAlign: "center", marginBottom: 0}}>
                <Row style={{maxWidth: 1200, margin: "0 auto"}}>
                  <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} style={{textAlign: "center", marginBottom: 35}} >
                  <Heading style={{padding: 0}}>Leads der letzten 90 Tage</Heading>
                  <div style={{ marginLeft: 15, marginRight: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "50%", maxWidth: 100, marginBottom: 10, display: "inline-block" }}></div>

                </Col>
                <Col xs={12} md={4} lg={4} className={'mobile-no-padding'} >
                    <NumberDisplay>{this.state.info_leads}</NumberDisplay>
                    <Information style={{opacity: 0.7}}>Info Anfragen</Information>
                </Col>
                <Col xs={12} md={4} lg={4} className={'mobile-no-padding'} >
                    <NumberDisplay>{this.state.application_leads}</NumberDisplay>
                    <Information>Bewerbungen</Information>
                    <Information style={{opacity: 0.7}}>(= {Math.ceil( this.state.application_leads / this.state.info_leads * 100 )} %)</Information>
                </Col>
                <Col xs={12} md={4} lg={4} className={'mobile-no-padding'} >
                    <NumberDisplay>{this.state.member_leads}</NumberDisplay>
                    <Information>Mitglieder</Information>
                    <Information style={{opacity: 0.7}}>(= {Math.ceil( this.state.member_leads / this.state.info_leads * 100 )} % der Info Anfragen)</Information>
                    <Information style={{opacity: 0.7}}>(= {Math.ceil( this.state.member_leads / this.state.application_leads * 100 )} % der Bewerbungen)</Information>
                </Col>
                </Row>
              </ContainerBox>
              <ContainerBox style={{paddingBottom: 25}}>
                  <Heading>Dashboard</Heading>
                  <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>

                  <Row>
                    <Col md={12}>
                      <LogeButtonSlim
                        hoverFontColor={"white"}
                        onClick={() => this.props.history.push(`/internal/admin/onboarding/new`)}>
                          Mitglied und Firma hinzufügen
                      </LogeButtonSlim>

                      <LogeButtonSlim
                        hoverFontColor={"white"}
                        onClick={() => this.props.history.push(`/internal/admin/members/new`)}>
                          Mitglied hinzufügen
                      </LogeButtonSlim>

                      <LogeButtonSlim
                        hoverFontColor={"white"}
                        onClick={() => this.props.history.push(`/internal/admin/companies/new`)}>
                          Firma hinzufügen
                      </LogeButtonSlim>
                    </Col>
                  </Row>

                </ContainerBox>
                <ContainerBox style={{paddingBottom: 25}}>
                  <Heading>Werkzeuge</Heading>
                  <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>

                  <Row>
                    <Col md={12}>
                      <LogeButtonSlim
                        hoverFontColor={"white"}
                        onClick={() => { this.confirmNewContractsModal.open() } }>
                          Verträge jetzt aussenden
                      </LogeButtonSlim>
                      <LogeButtonSlim
                        hoverFontColor={"white"}
                        onClick={() => { this.confirmNewInvoicesModal.open() } }>
                          Rechnungen jetzt aussenden
                      </LogeButtonSlim>
                    </Col>
                  </Row>

                </ContainerBox>

                <ContainerBox style={{paddingBottom: 25}}>
                  <Heading>Bewerbungen</Heading>
                  <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>

                  <Row>

                    <Col md={12}>
                      <div style={{ color: 'black', margin: 15 }} className={'bootstrap-table contracts'}>
                        <ApplicationTable data={ applications } onRowClick="details" pagination/>
                      </div>
                    </Col>

                    <Col md={12}>
                      <LogeButtonSlim
                        hoverFontColor={"white"}
                        onClick={() => this.props.history.push(`/internal/admin/applications`)}>
                          Alle Bewerbungen anzeigen
                      </LogeButtonSlim>
                    </Col>
                  </Row>

                </ContainerBox>
              </Col>
            </Row>
            <ConfirmSendNewContractsModal
              ref={instance => { this.confirmNewContractsModal = instance; }}/>
            <ConfirmSendNewInvoicesModal
              ref={instance => { this.confirmNewInvoicesModal = instance; }}/>
          </div>
          : ''}

      </div>
    )
  }
}

const NumberDisplay = styled.div `
  font-size: 50px;
  color: #212D3D;
	display: block;
	font-family: "Lora";
`
const Information = styled.div `
  font-size: 18px;
  color: #212D3D;
	display: block;
	font-family: "Catamaran";
`

Dashboard.propTypes = {
  golfCourseStore: MobxPropTypes.observableObject
}

export default Dashboard



// WEBPACK FOOTER //
// /src/components/admin/Dashboard.js